module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "gosat-based-ch4budget-yeargrid-v1.thumbnails.priori.total.00e4c59a.png";